module.exports = __webpack_public_path__ + "lemon_vue/img/franke-dianqi.b34a934.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/franke-dianqi.png
// module id = kckw
// module chunks = 1